/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { lazy } from 'react';

/**
 * The credit-risk panel, loaded on demand.
 *
 * `RiskDimensionRadar` pulls in recharts (~208 KB minified), and the panel sits behind
 * FF_APP_CREDIT_RISK, which is false in every environment -- so a static import made
 * the whole application pay for a tab nobody can open. The dynamic import is the
 * boundary Rollup splits on, which keeps recharts out of the entry chunk.
 *
 * Two details this module exists to get right, both of which fail silently otherwise:
 * the import targets the component file directly, because going through the
 * ClientRiskScore barrel would re-export RiskDimensionRadar and drag recharts back in;
 * and RiskScorePanel is a named export, so it has to be mapped onto `default` for
 * React.lazy, which only accepts a module whose default is the component.
 */
export const RiskScorePanel = lazy(() =>
  import('./RiskScorePanel').then((m) => ({ default: m.RiskScorePanel })),
);
